import React, { useState } from 'react';
import {
  DataGrid,
  Text,
  useResponsiveParams,
  HideOnDesktop,
  Button,
  NotificationList,
} from 'quanta-ui';
import { useQuery } from '@apollo/client';
import {
  GET_BUY_HEALTH_POLICY_VAR_DETAILS,
  GET_DATE_TIME,
  GET_GENDER_LIST,
  SEND_PROPOSAL_PDF,
} from '../queries';
// import Loading from '../../../../../lib/layout/loading';
// import Error from '../../../../../lib/layout/error';
import { Loading ,Error} from 'quanta-flows/modules/layout';
import {
  faDownload,
  faInfoCircle,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import ModalViewBreakup from '../../../../common/view-breakup/health/view-breakup';
import ModalViewBreakup from './modal-view-breakup';
// import CurrencyFormater from '../../../../../lib/intl/CurrencyFormater';
import { CurrencyFormater } from 'quanta-flows';
// import useFetchQuery from '../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery,useMutationQuery } from 'quanta-flows';
// import useMutationQuery from '../../../../../lib/graphql/useMutationQuery';
import { useParams } from 'react-router-dom';
// console.log("buyHealthPolicyData--------------------------------->",product_code);
export default function QuoteSummary({
  // lobCode,
  // lobName,
  productName,
  // productCode,
  planName,
  planCode,
  // proposalNumber,
}) {
  // console.log("buyHealthPolicyData--------------------------------->",product_code);
  const { loading, error, data: dataBuyHealthPolicy } = useQuery(
    GET_BUY_HEALTH_POLICY_VAR_DETAILS,
  );
  const [showViewBreakup, setShowViewBreakup] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const fetchQuery = useFetchQuery();
  const mutateQuery = useMutationQuery();

  const {
    loading: loadingGenderList,
    error: errorGenderList,
    data: dataGenderList,
  } = useQuery(GET_GENDER_LIST, { fetchPolicy: 'cache-first' });

  const params = useParams();
  const product_name = productName
    ? productName
    : params?.product_name;
  const plan_name = planName ? planName : params?.plan_name;
  const plan_code = planCode ? planCode : params?.plan_code;
  const { product_code } = params;
  if (dataBuyHealthPolicy) {
    var buyHealthPolicy = dataBuyHealthPolicy?.buyHealthPolicy;
    var planData = buyHealthPolicy?.planData;
    var plans = planData?.plans;
  }
  if (dataGenderList) {
    var { genderList } = dataGenderList;
  }

  let screenSize = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
    for_iPad: 'iPad',
  });

  let repeat = useResponsiveParams({
    for_mobile: 2,
    for_iPad: 4,
  });
  // console.log("buyHealthPolicyData--------------------------------->",buyHealthPolicyData);
  const getBase64Var = (buyHealthPolicyData, getDateTimeData) => {
    const getInsuredDetailsObj = (
      insuredDetails,
      nomineeDetails,
      prevInsuranceDetails,
      medicalQuestionaire,
      planData,
      isHealthDeclarationSelected,
    ) => {
      let insuredDetailsResponseArr = [];
      insuredDetails.forEach((insured) => {
        const {
          ppcTestLevel,
          memberID,
          memberStatus,
          ...restInsured
        } = insured;
        let insuredObj = { ...restInsured };

        const nomineeObj = nomineeDetails?.find(
          (nominee) =>
            nominee?.relationship?.toLowerCase() ===
            insured?.relationship?.toLowerCase(),
        );
        const { relationship, ...restNomineeObj } = nomineeObj;
        insuredObj.nomineeDetails = {
          ...restNomineeObj,
          insuredRelationship: relationship,
        };

        const prevInsuranceInput = prevInsuranceDetails?.find(
          (prevInsured) =>
            prevInsured?.insuredRelationship?.toLowerCase() ===
            insured?.relationship?.toLowerCase(),
        );

        insuredObj.prevInsuranceInput = {
          prevInsurerName: prevInsuranceInput?.prevInsurerName,
          prevPolicyNo: prevInsuranceInput?.prevPolicyNo,
          prevPolicySI: prevInsuranceInput?.prevPolicySI,
          prevClaimLodged:
            prevInsuranceInput?.prevClaimLodged?.toLowerCase() ===
            'yes'
              ? true
              : false,
          claimAmount: prevInsuranceInput?.claimAmount,
          prevPolicyStartDate:
            prevInsuranceInput?.prevPolicyStartDate,
          prevPolicyEndDate: prevInsuranceInput?.prevPolicyEndDate,
          cbAmount: prevInsuranceInput?.cbAmount,
        };

        let medicalQuestionaireObj = isHealthDeclarationSelected
          ? medicalQuestionaire?.find(
              (m) =>
                m?.relationship?.toLowerCase() ===
                insured?.relationship?.toLowerCase(),
            )
          : { relationship: insured?.relationship, questions: [] };

        if (
          medicalQuestionaireObj &&
          medicalQuestionaireObj?.questions?.length > 0
        ) {
          medicalQuestionaireObj = {
            ...medicalQuestionaireObj,
            questions: medicalQuestionaireObj?.questions?.map(
              (question) => {
                return {
                  srNo: question?.srNo,
                  answer: question?.answer?.answerText,
                };
              },
            ),
          };
          medicalQuestionaireObj = {
            ...medicalQuestionaireObj,
            questions:
              medicalQuestionaireObj?.questions
                ?.find((q) => q?.srNo?.toLowerCase() === 'master')
                ?.answer?.toLowerCase() === 'no'
                ? medicalQuestionaireObj?.questions?.filter(
                    (q) => q?.srNo?.toLowerCase() !== 'master',
                  )
                : [],
          };
        }
        insuredObj.medicalQuestionaire = medicalQuestionaireObj
          ? medicalQuestionaireObj
          : { relationship: insured?.relationship, questions: [] };

        const { plans } = planData;
        insuredObj.addOnCovers = plans
          ?.find(
            (p) => 
            p?.name?.toLowerCase() === plan_name?.toLowerCase(),
          )
          ?.packs?.filter((pack) =>
            pack?.index?.includes(insured?.relationship),
          )
          .flatMap((pack) =>
            pack.addOnCovers.filter(
              (addOnCover) => addOnCover.selected,
            ),
          );

        if (!insuredObj.addOnCovers) {
          insuredObj.addOnCovers = [];
        }

        insuredDetailsResponseArr.push(insuredObj);
      });
      return insuredDetailsResponseArr;
    };
    const {
      crn,
      isNewCustomer,
      ciuType,isCRNVerified,
      ...restProposerMetaData
    } = buyHealthPolicyData?.proposerDetailsMeta;
    return {
      input: {
        proposerDetails: {
          ...restProposerMetaData,
          ...buyHealthPolicyData?.proposerDetails,
          isThinCustomer: false,
        },
        insuredDetails: getInsuredDetailsObj(
          buyHealthPolicyData?.insuredDetails,
          buyHealthPolicyData?.nomineeDetails,
          buyHealthPolicyData?.prevInsuranceDetails,
          buyHealthPolicyData?.medicalQuestionaire,
          buyHealthPolicyData?.planData,
          buyHealthPolicyData?.isHealthDeclarationSelected?.toLowerCase() ===
            'yes',
        ),
        plan: {
          name: plan_name,
          code: plan_code,
          covers:
            buyHealthPolicyData?.planData?.plans?.find(
              (plan) =>
                plan?.name?.toLowerCase() === plan_name?.toLowerCase(),
            )?.covers?.length > 0
              ? buyHealthPolicyData?.planData?.plans?.find(
                  (plan) =>
                    plan?.name?.toLowerCase() ===
                    plan_name?.toLowerCase(),
                )?.covers
              : [],
          packs:
            buyHealthPolicyData?.planData?.plans?.find(
              (plan) =>
                plan?.name?.toLowerCase() === plan_name?.toLowerCase(),
            )?.packs?.length > 0
              ? buyHealthPolicyData?.planData?.plans?.find(
                  (plan) =>
                    plan?.name?.toLowerCase() ===
                    plan_name?.toLowerCase(),
                )?.packs
              : [],
          premium: buyHealthPolicyData?.planData?.plans?.find(
            (plan) =>
              plan?.name?.toLowerCase() === plan_name?.toLowerCase(),
          )?.premium,
        },
        intermediary: {
          intermediaryCode: buyHealthPolicyData?.intermediaryDetails
            ?.code
            ? `${buyHealthPolicyData?.intermediaryDetails?.code}`
            : '',
          locationCode: buyHealthPolicyData?.intermediaryDetails
            ?.location
            ? `${buyHealthPolicyData?.intermediaryDetails?.location}`
            : '',
          fieldUserCode: buyHealthPolicyData?.intermediaryDetails
            ?.fieldUserCode
            ? `${buyHealthPolicyData?.intermediaryDetails?.fieldUserCode}`
            : '',
        },
        zone: buyHealthPolicyData?.quoteData?.location?.zone?.trim(),
        quotationType: buyHealthPolicyData?.quotationType,
        sumInsured: parseFloat(
          buyHealthPolicyData?.quoteData?.cover?.sum_insured,
        ),
        deductSumInsured: parseFloat(
          buyHealthPolicyData?.quoteData.deductSumInsured,
        ),
        startDate: getDateTimeData?.datetimeValue?.date,
        startTime: '00:00',
        coverType: buyHealthPolicyData?.quoteData?.cover?.type,
        tenure: buyHealthPolicyData?.quoteData?.cover?.tenure,
        proposalPaymentType: buyHealthPolicyData?.proposalPaymentType,
        isHealthDeclarationSelected:
          buyHealthPolicyData?.isHealthDeclarationSelected?.toLowerCase() ===
          'yes',
        quoteNumber: buyHealthPolicyData?.quoteNumber,
        productCode: product_code,
        policyNumber: buyHealthPolicyData?.quoteData?.policyNumber,
        employeeNumber:
          buyHealthPolicyData?.quoteData?.employeeNumber,
        proposerPincode:
          buyHealthPolicyData?.quoteData?.location?.pincode,
        /* Renew mandate */
        renewalMandateDetails: {
          renewalPaymentMandate:
            buyHealthPolicyData?.renewalMandateDetails
              ?.renewalPaymentMandate,
          renewalPaymentMandateTakenInNameOf:
            buyHealthPolicyData?.renewalMandateDetails
              ?.renewalPaymentMandateTakenInNameOf,
          termForMandateOpted:
            buyHealthPolicyData?.renewalMandateDetails
              ?.termForMandateOpted,
          typeOfDebit:
            buyHealthPolicyData?.renewalMandateDetails?.typeOfDebit,
          accountNumber:
            buyHealthPolicyData?.renewalMandateDetails?.accountNumber,
          destinationBankName:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationBankName,
          destinationIfscCode:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationIfscCode,
          destinationMicrCode:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationMicrCode,
          destinationBranchName:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationBranchName,
          mandateAmount: parseFloat(
            buyHealthPolicyData?.renewalMandateDetails?.mandateAmount,
          ),
          finalCollectionDate:
            buyHealthPolicyData?.renewalMandateDetails
              ?.finalCollectionDate,
          destinationBankAccountType:
            buyHealthPolicyData?.renewalMandateDetails
              ?.destinationBankAccountType,
        },
      },
      proposalNumber: buyHealthPolicyData?.proposalNumber,
    };
  };

  const data = [
    plan_name
      ? {
          label: (
            <Text severity={'info'} className="ml-1">
              Plan Name
            </Text>
          ),
          text: <Text className="ml-1">{plan_name}</Text>,
        }
      : null,
    {
      label: (
        <Text severity={'info'} className="">
          Annual Premium
        </Text>
      ),
      className:
        screenSize?.toString()?.toLowerCase() === 'ipad' ? '' : '',
      text: (
        <div className="space-x-2 flex items-center">
          <Text type="larger" severity="info">
            {CurrencyFormater(
              plans?.find((p) => p.name === plan_name)?.premium
                ?.totalPremium,
            )}
          </Text>
          <Text
            severity="info"
            onClick={(_) => {
              setShowViewBreakup(true);
            }}
            className="cursor-pointer mt-1"
          >
            <FontAwesomeIcon icon={faInfoCircle} />
          </Text>
        </div>
      ),
    },
    {
      label: (
        <Text severity="info" className="ml-1">
          Proposal Number
        </Text>
      ),
      text: buyHealthPolicy?.proposalNumber ? (
        <Text className="ml-1">
          {buyHealthPolicy?.proposalNumber}
        </Text>
      ) : (
        <Text severity="neutral-darker" className="ml-1">
          Not Captured
        </Text>
      ),
    },
    {
      className:
        screenSize?.toString()?.toLowerCase() === 'ipad' ? '' : '',
      text: (
        <Text className="mt-1 mb-1 flex items-center h-full">
          <Button
            size={screenSize === 'iPad' ? 'medium' : 'small'}
            flat
            className={`h-8 ${
              screenSize === 'mobile' ? '' : 'border-none'
            } ${
              !dataBuyHealthPolicy?.buyHealthPolicy?.proposalNumber
                .length > 0 || loadingDownload
                ? 'border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                : ''
            }`}
            onClick={async (_) => {
              if (
                dataBuyHealthPolicy?.buyHealthPolicy?.proposalNumber
                  ?.length > 0 &&
                !loadingDownload
              ) {
                try {
                  let getDateTime = fetchQuery({
                    query: GET_DATE_TIME,
                  });
                  setAlerts([]);
                  setLoadingDownload(true);

                  let { data: getDateTimeData } = await getDateTime;

                  let proposalPDFBase64String = mutateQuery({
                    mutation: SEND_PROPOSAL_PDF,
                    variables: getBase64Var(
                      buyHealthPolicy,
                      getDateTimeData,
                    ),
                  });

                  let {
                    data: dataBase64String,
                  } = await proposalPDFBase64String;
                  const { sendProposalPDF } = dataBase64String;
                  const {
                    base64Pdf: downloadBase64String,
                  } = sendProposalPDF;
                  setLoadingDownload(false);

                  let byteCharacters = atob(
                    downloadBase64String.toString(),
                  );
                  let byteNumbers = new Array(byteCharacters.length);
                  for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                  }
                  let byteArray = new Uint8Array(byteNumbers);
                  let file = new Blob([byteArray], {
                    type: 'application/pdf;base64',
                  });
                  let fileURL = URL.createObjectURL(file);
                  window.open(fileURL);
                } catch (error) {
                  setAlerts([
                    {
                      id: Date.now(),
                      content: (
                        <div className="flex flex-col w-full h-full">
                          <Text type="normal">{error.message}</Text>
                        </div>
                      ),
                      type: 'error',
                      timeout: null,
                      disableClose: false,
                    },
                  ]);
                  setLoadingDownload(false);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }
            }}
          >
            <FontAwesomeIcon
              icon={loadingDownload ? faSpinner : faDownload}
              className="mr-1.5"
              spin={loadingDownload}
              size="lg"
            />
            {loadingDownload ? 'Downloading...' : 'Download Form'}
          </Button>
        </Text>
      ),
    },
  ].filter((d) => d);

  return (
    <>
      {loading || loadingGenderList ? (
        <Loading />
      ) : error || errorGenderList ? (
        <Error error={error || errorGenderList} />
      ) : !buyHealthPolicy?.isPolicyIssued ? (
        screenSize !== 'desktop' ? (
          <div className="bg-neutral sticky bottom-0 pt-1 -mx-4 mt-2 -mb-4 z-20">
            <div className="p-2 pb-3">
              <DataGrid
                textType="normal"
                {...{ data }}
                repeat={repeat}
                gapX={20}
                nullData={() => (
                  <Text severity="neutral">Not Captured</Text>
                )}
              />
              <ModalViewBreakup
                {...{
                  showViewBreakup,
                  setShowViewBreakup,
                  selectedPlanTypeView: plan_name,
                  product_code,
                  genderList,
                  quoteData: buyHealthPolicy?.quoteData,
                  planData: buyHealthPolicy?.planData,
                  title: 'Premium Breakup for Proposal',
                }}
              />
            </div>
            <div>
              <NotificationList {...{ items: alerts }} />
            </div>
          </div>
        ) : (
          <></>
        )
      ) : null}
    </>
  );
}
